import React from 'react';
import styles from './MProgressBar.module.css';

export type MProgressBarSize = 'large' | 'medium' | 'small';

interface MProgressBarProps {
  progress: number; // 0-100
  size?: MProgressBarSize;
  className?: string;
}

const sizeToClass = {
  large: styles.large,
  medium: styles.medium,
  small: styles.small,
};

export const MProgressBar: React.FC<MProgressBarProps> = ({ progress, size = 'large', className }) => {
  const clampProgress = Math.max(0, Math.min(progress, 100));
  return (
    <div
      className={[
        styles.root,
        sizeToClass[size],
        className || '',
      ].join(' ')}
      role="progressbar"
      aria-valuenow={clampProgress}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={styles.fill}
        style={{ width: `${clampProgress}%` }}
      />
    </div>
  );
};

export default MProgressBar;
